module.exports = "/img/_/_/_/assets/images/creeper/book/common//1.jpg?f509b6d5f019c87be1f72aefb43142cb";